import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fc54d21"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Xuất Excel", -1))
const _hoisted_6 = {
  class: "thu-hoi-action-menu__dropdown",
  role: "menu",
  "aria-label": "Xuất Excel"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tạo BC Tổng hợp", -1))
const _hoisted_10 = { class: "mb-3 d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_11 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Xem PDF", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7" }, " Chọn vật tư để xem chi tiết (một / một phần / tất cả). ", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Chọn tất cả", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bỏ chọn", -1))
const _hoisted_22 = { class: "mb-3 d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_23 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Xem PDF", -1))
const _hoisted_25 = {
  key: 0,
  class: "mb-3 d-flex align-items-center gap-3 flex-wrap"
}
const _hoisted_26 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Xem PDF", -1))
const _hoisted_28 = {
  key: 2,
  class: "text-center text-muted py-5"
}
const _hoisted_29 = {
  key: 0,
  class: "mb-3 d-flex align-items-center gap-3 flex-wrap"
}
const _hoisted_30 = {
  class: "thu-hoi-action-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Xem PDF", -1))
const _hoisted_32 = {
  key: 2,
  class: "text-center text-muted py-5"
}

import moment from "moment";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faCheckDouble,
  faChevronDown,
  faFileExcel,
  faFileExport,
  faFilePdf,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Can from "@/components/Can.vue";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import { openBaoCaoPdf } from "@/components/shared/pdf-viewer/open-bao-cao-pdf";
import { BAO_CAO_SO_CAN_DOI } from "@/core/constants/permissions";
import ReportType from "@/core/enums/ReportTypes.enums";
import {
  formatMonthQuery,
  formatVatTuIdsQuery,
  type ThuHoiVtptSheet,
} from "@/core/helpers/bao-cao-pdf-params";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import { downloadBase64File, swalErrNotification } from "@/core/helpers/utils";
import { useCreatingForm } from "@/core/hooks/use-creating-form";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import useFormInput from "@/core/hooks/use-form-input";
import { useLoading } from "@/core/hooks/use-loading";
import { IKhoResponseBase } from "@/core/interfaces/ApiResponses";
import { BaoCaoService } from "@/core/services/BaoCao.service";
import { KhoService } from "@/core/services/Kho.service";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageContentSection from "@/layout/_shared/PageContentSection.vue";
import type { ThuHoiVtptDetail, ThuHoiVtptSummary } from "@/types/thu-hoi-vtpt";
import ThuHoiB01aTable from "./table-components/ThuHoiB01aTable.vue";
import ThuHoiB01bTable from "./table-components/ThuHoiB01bTable.vue";
import ThuHoiB02aTable from "./table-components/ThuHoiB02aTable.vue";
import ThuHoiB02bTable from "./table-components/ThuHoiB02bTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiVtptThuHoi',
  setup(__props) {

setCurrentPageTitle("Theo dõi VTPT thu hồi");

setBreadcrumbLinks([{ text: "Báo cáo" }, { text: "Theo dõi VTPT thu hồi" }]);

document.title = "Theo dõi VTPT thu hồi - Đường sắt Hà Nội";

const store = useStore();
const router = useRouter();
const currentYear = computed(() => store.getters.getSelectedYear);
const { disableDate, defaultDate } = useDateTime();
const { formRef } = useCreatingForm();
const { startLoading, endLoading } = useLoading();
const { focusFirstErrInputV2 } = useFormInput();

const form = ref({
  from: defaultDate.value,
  to: defaultDate.value,
  khoId: -1,
});

const isFiltersChanging = ref(true);
const khoItems = ref<IKhoResponseBase[]>([]);
const summary = ref<ThuHoiVtptSummary | null>(null);
const detail = ref<ThuHoiVtptDetail | null>(null);
const selectedVatTuIds = ref<number[]>([]);
const tenDonVi = ref<string | null>(null);
const tenDonViCha = ref<string | null>(null);
const activeTab = ref("b01_b");
const excelMenuOpen = ref(false);
const excelMenuRef = ref<HTMLElement | null>(null);

const fromDateValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập"));
    return;
  }

  if (value && form.value.to && moment(value).isAfter(form.value.to)) {
    callback(new Error("Từ tháng phải trước hoặc bằng đến tháng"));
    return;
  }

  callback();
};

const toDateValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập"));
    return;
  }

  if (value && form.value.from && moment(value).isBefore(form.value.from)) {
    callback(new Error("Đến tháng phải sau hoặc bằng từ tháng"));
    return;
  }

  callback();
};

const rules = ref({
  from: [{ validator: fromDateValidation, trigger: "change" }],
  to: [{ validator: toDateValidation, trigger: "change" }],
  khoId: [
    {
      type: "number",
      message: "Phải chọn kho",
      trigger: "change",
      min: 1,
    },
  ],
});

const buildQuery = () => ({
  id_kho: form.value.khoId,
  from_month: form.value.from.getMonth() + 1,
  to_month: form.value.to.getMonth() + 1,
});

const buildDetailQuery = () => ({
  ...buildQuery(),
  id_vat_tu: selectedVatTuIds.value,
});

const fetchKhoItems = async () => {
  startLoading();

  try {
    const {
      data: {
        data: { data },
      },
    } = await KhoService.fetchAllWarehouses();

    khoItems.value = data;
    await endLoading();
  } catch (e) {
    await endLoading();
    swalErrNotification(e, "Có lỗi khi lấy danh sách kho");
  }
};

const selectAllMaterials = () => {
  if (!summary.value) return;
  selectedVatTuIds.value = summary.value.b01_b.rows.map((row) => row.id_vat_tu);
};

const toggleExcelMenu = () => {
  excelMenuOpen.value = !excelMenuOpen.value;
};

const onExportSummaryClick = () => {
  excelMenuOpen.value = false;
  exportSummary();
};

const onExportDetailClick = () => {
  if (!showDetailActions.value) return;
  excelMenuOpen.value = false;
  void exportDetail();
};

const openPdfViewer = (sheet: ThuHoiVtptSheet) => {
  if (!summary.value) return;

  const isDetailSheet = sheet === "b01_a" || sheet === "b02_a";
  const vatTuIds = isDetailSheet
    ? detail.value?.id_vat_tu?.length
      ? detail.value.id_vat_tu
      : selectedVatTuIds.value
    : [];

  if (isDetailSheet && !vatTuIds.length) {
    swalErrNotification(null, "Chọn vật tư và tạo báo cáo chi tiết trước");
    return;
  }

  openBaoCaoPdf(router, {
    reportType: ReportType.THEO_DOI_VTPT_THU_HOI,
    from: formatMonthQuery(new Date(form.value.from)),
    to: formatMonthQuery(new Date(form.value.to)),
    year: Number(currentYear.value),
    khoId: form.value.khoId,
    sheet,
    ...(isDetailSheet ? { vatTuIds: formatVatTuIdsQuery(vatTuIds) } : {}),
  });
};

const onDocumentClick = (event: MouseEvent) => {
  if (!excelMenuOpen.value || !excelMenuRef.value) return;

  const target = event.target as Node | null;
  if (target && !excelMenuRef.value.contains(target)) {
    excelMenuOpen.value = false;
  }
};

const loadSummary = () => {
  if (!formRef.value) return;

  formRef.value.validate(async (isValid) => {
    if (!isValid) {
      await focusFirstErrInputV2();
      return false;
    }

    startLoading();

    try {
      const { data } = await BaoCaoService.getThuHoiVtptSummary(buildQuery());

      summary.value = data.data;
      detail.value = null;
      selectedVatTuIds.value = [];
      tenDonVi.value = data.extra?.ten_don_vi ?? null;
      tenDonViCha.value = data.extra?.ten_don_vi_cha ?? null;
      isFiltersChanging.value = false;
      activeTab.value = "b01_b";
      excelMenuOpen.value = false;

      await endLoading();
    } catch (e) {
      await endLoading();
      swalErrNotification(e, "Có lỗi khi tải báo cáo tổng hợp");
    }
  });
};

const loadDetail = async () => {
  if (!selectedVatTuIds.value.length) {
    swalErrNotification(null, "Phải chọn ít nhất một vật tư để xem chi tiết");
    return;
  }

  startLoading();

  try {
    const { data } = await BaoCaoService.getThuHoiVtptDetail(
      buildDetailQuery()
    );

    detail.value = data.data;
    tenDonVi.value = data.extra?.ten_don_vi ?? tenDonVi.value;
    tenDonViCha.value = data.extra?.ten_don_vi_cha ?? tenDonViCha.value;
    activeTab.value = "b01_a";

    await endLoading();
  } catch (e) {
    await endLoading();
    swalErrNotification(e, "Có lỗi khi tải báo cáo chi tiết");
  }
};

const exportSummary = () => {
  if (!formRef.value) return;

  formRef.value.validate(async (isValid) => {
    if (!isValid) {
      await focusFirstErrInputV2();
      return false;
    }

    startLoading();

    try {
      const {
        data: {
          data: { filename, file_data, mime_type },
        },
      } = await BaoCaoService.exportThuHoiVtptSummary(buildQuery());

      await downloadBase64File(file_data, mime_type, filename);
      await endLoading();
    } catch (e) {
      await endLoading();
      swalErrNotification(e, "Có lỗi khi xuất Excel tổng hợp");
    }
  });
};

const exportDetail = async () => {
  if (!selectedVatTuIds.value.length) {
    swalErrNotification(null, "Phải chọn ít nhất một vật tư để xuất chi tiết");
    return;
  }

  startLoading();

  try {
    const {
      data: {
        data: { filename, file_data, mime_type },
      },
    } = await BaoCaoService.exportThuHoiVtptDetail(buildDetailQuery());

    await downloadBase64File(file_data, mime_type, filename);
    await endLoading();
  } catch (e) {
    await endLoading();
    swalErrNotification(e, "Có lỗi khi xuất Excel chi tiết");
  }
};

const showSummaryActions = computed(() => {
  if (isFiltersChanging.value) return false;
  return !!summary.value;
});

const showDetailActions = computed(() => {
  if (!showSummaryActions.value) return false;
  return selectedVatTuIds.value.length > 0;
});

onMounted(async () => {
  await fetchKhoItems();
  document.addEventListener("click", onDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick, true);
});

watch(
  form,
  () => {
    isFiltersChanging.value = true;
    summary.value = null;
    detail.value = null;
    selectedVatTuIds.value = [];
    excelMenuOpen.value = false;
  },
  { deep: true }
);

watch(selectedVatTuIds, () => {
  detail.value = null;

  if (activeTab.value === "b01_a" || activeTab.value === "b02_a") {
    activeTab.value = "b01_b";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(PageContentBase, { plain: "" }, {
    default: _withCtx(() => [
      _createVNode(PageContentSection, { "always-expanded": true }, {
        header: _withCtx(() => [
          _createTextVNode("Theo dõi VTPT thu hồi")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            rules: rules.value,
            onSubmit: _withModifiers(loadSummary, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                gutter: 10,
                align: "bottom",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    lg: 6,
                    md: 8,
                    sm: 12,
                    xl: 5,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, {
                        "is-text-muted": false,
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Kho:")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "khoId",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: form.value.khoId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.khoId) = $event)),
                            class: "w-100",
                            name: "khoId",
                            filterable: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Chưa chọn",
                                value: -1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(khoItems.value, (kho) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: kho.id,
                                  label: kho.ten_kho,
                                  value: kho.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    lg: 4,
                    md: 8,
                    sm: 12,
                    xl: 3,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, {
                        "is-text-muted": false,
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Từ tháng:")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "from",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: form.value.from,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.from) = $event)),
                            class: "w-100",
                            "disabled-date": (time) => _unref(disableDate)(time, currentYear.value, true),
                            type: "month",
                            placeholder: "Từ",
                            name: "from",
                            format: "MM/YYYY"
                          }, null, 8, ["modelValue", "disabled-date"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    lg: 4,
                    md: 8,
                    sm: 12,
                    xl: 3,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, {
                        "is-text-muted": false,
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Đến tháng:")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "to",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: form.value.to,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.to) = $event)),
                            class: "w-100",
                            "disabled-date": (time) => _unref(disableDate)(time, currentYear.value, true),
                            type: "month",
                            placeholder: "Đến",
                            name: "to",
                            format: "MM/YYYY"
                          }, null, 8, ["modelValue", "disabled-date"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-4" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 6 }, {
                    default: _withCtx(() => [
                      (summary.value && !isFiltersChanging.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", null, _toDisplayString(tenDonViCha.value || "Công ty CP Vận tải Đường sắt"), 1),
                            (tenDonVi.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Chi nhánh: " + _toDisplayString(tenDonVi.value), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createTextVNode(" Từ tháng " + _toDisplayString(summary.value.from_month) + " năm " + _toDisplayString(summary.value.year) + " đến tháng " + _toDisplayString(summary.value.to_month) + " năm " + _toDisplayString(summary.value.year) + " ", 1),
                              (summary.value.ten_kho)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " — " + _toDisplayString(summary.value.ten_kho), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    cols: 6,
                    class: "thu-hoi-actions d-flex justify-content-end flex-wrap"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Can, {
                        all: [_unref(BAO_CAO_SO_CAN_DOI).XUAT_EXCEL]
                      }, {
                        default: _withCtx(() => [
                          (showSummaryActions.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                ref_key: "excelMenuRef",
                                ref: excelMenuRef,
                                class: "thu-hoi-action-menu"
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["thu-hoi-action-btn thu-hoi-action-btn--excel", { 'thu-hoi-action-btn--open': excelMenuOpen.value }]),
                                  onClick: toggleExcelMenu
                                }, [
                                  _createElementVNode("span", _hoisted_4, [
                                    _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFileExcel) }, null, 8, ["icon"])
                                  ]),
                                  _hoisted_5,
                                  _createVNode(_unref(FontAwesomeIcon), {
                                    icon: _unref(faChevronDown),
                                    class: _normalizeClass(["thu-hoi-action-btn__chevron", {
                      'thu-hoi-action-btn__chevron--open': excelMenuOpen.value,
                    }])
                                  }, null, 8, ["icon", "class"])
                                ], 2),
                                _withDirectives(_createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "thu-hoi-action-menu__item",
                                    role: "menuitem",
                                    onClick: onExportSummaryClick
                                  }, " Xuất Excel tổng hợp "),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "thu-hoi-action-menu__item",
                                    role: "menuitem",
                                    disabled: !showDetailActions.value,
                                    onClick: onExportDetailClick
                                  }, " Xuất Excel Chi tiết ", 8, _hoisted_7)
                                ], 512), [
                                  [_vShow, excelMenuOpen.value]
                                ])
                              ], 512))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["all"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "thu-hoi-action-btn thu-hoi-action-btn--summary",
                        onClick: loadSummary
                      }, [
                        _createElementVNode("span", _hoisted_8, [
                          _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFileExport) }, null, 8, ["icon"])
                        ]),
                        _hoisted_9
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          (summary.value && !isFiltersChanging.value)
            ? (_openBlock(), _createBlock(_component_el_tabs, {
                key: 0,
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((activeTab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "B01.b Tổng hợp tái SD",
                    name: "b01_b"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "thu-hoi-action-btn thu-hoi-action-btn--pdf",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (openPdfViewer('b01_b')))
                        }, [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFilePdf) }, null, 8, ["icon"])
                          ]),
                          _hoisted_12
                        ]),
                        _hoisted_13,
                        _createElementVNode("button", {
                          type: "button",
                          class: "thu-hoi-action-btn thu-hoi-action-btn--detail",
                          disabled: !selectedVatTuIds.value.length,
                          onClick: loadDetail
                        }, [
                          _createElementVNode("span", _hoisted_15, [
                            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFileExport) }, null, 8, ["icon"])
                          ]),
                          _createElementVNode("span", null, "Tạo BC Chi tiết (" + _toDisplayString(selectedVatTuIds.value.length) + ")", 1)
                        ], 8, _hoisted_14),
                        _createElementVNode("button", {
                          type: "button",
                          class: "thu-hoi-action-btn thu-hoi-action-btn--select",
                          disabled: !summary.value.b01_b.rows.length,
                          onClick: selectAllMaterials
                        }, [
                          _createElementVNode("span", _hoisted_17, [
                            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faCheckDouble) }, null, 8, ["icon"])
                          ]),
                          _hoisted_18
                        ], 8, _hoisted_16),
                        _createElementVNode("button", {
                          type: "button",
                          class: "thu-hoi-action-btn thu-hoi-action-btn--clear",
                          disabled: !selectedVatTuIds.value.length,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedVatTuIds.value = []))
                        }, [
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faXmark) }, null, 8, ["icon"])
                          ]),
                          _hoisted_21
                        ], 8, _hoisted_19)
                      ]),
                      _createVNode(ThuHoiB01bTable, {
                        "selected-ids": selectedVatTuIds.value,
                        "onUpdate:selectedIds": _cache[5] || (_cache[5] = ($event: any) => ((selectedVatTuIds).value = $event)),
                        selectable: "",
                        rows: summary.value.b01_b.rows,
                        totals: summary.value.b01_b.totals
                      }, null, 8, ["selected-ids", "rows", "totals"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "B02.b Tổng hợp thanh lý",
                    name: "b02_b"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "thu-hoi-action-btn thu-hoi-action-btn--pdf",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (openPdfViewer('b02_b')))
                        }, [
                          _createElementVNode("span", _hoisted_23, [
                            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFilePdf) }, null, 8, ["icon"])
                          ]),
                          _hoisted_24
                        ])
                      ]),
                      _createVNode(ThuHoiB02bTable, {
                        rows: summary.value.b02_b.rows,
                        totals: summary.value.b02_b.totals
                      }, null, 8, ["rows", "totals"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "B01.a Chi tiết tái SD",
                    name: "b01_a",
                    disabled: !detail.value
                  }, {
                    default: _withCtx(() => [
                      (detail.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "thu-hoi-action-btn thu-hoi-action-btn--pdf",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (openPdfViewer('b01_a')))
                            }, [
                              _createElementVNode("span", _hoisted_26, [
                                _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFilePdf) }, null, 8, ["icon"])
                              ]),
                              _hoisted_27
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (detail.value)
                        ? (_openBlock(), _createBlock(ThuHoiB01aTable, {
                            key: 1,
                            blocks: detail.value.b01_a
                          }, null, 8, ["blocks"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, " Chọn vật tư ở B01.b rồi bấm Tạo BC Chi tiết. "))
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_tab_pane, {
                    label: "B02.a Chi tiết thanh lý",
                    name: "b02_a",
                    disabled: !detail.value
                  }, {
                    default: _withCtx(() => [
                      (detail.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "thu-hoi-action-btn thu-hoi-action-btn--pdf",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (openPdfViewer('b02_a')))
                            }, [
                              _createElementVNode("span", _hoisted_30, [
                                _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faFilePdf) }, null, 8, ["icon"])
                              ]),
                              _hoisted_31
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (detail.value)
                        ? (_openBlock(), _createBlock(ThuHoiB02aTable, {
                            key: 1,
                            blocks: detail.value.b02_a
                          }, null, 8, ["blocks"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, " Chọn vật tư ở B01.b rồi bấm Tạo BC Chi tiết. "))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})